import { cx } from '@linaria/core';
import { resets } from '@ui/css';
import { withSlots } from '@utils/react';
import { Checkmark } from './atom.checkmark.js';
import { contextMenu, wrapper, badgeWrapperCls, imageCls, badgeCls, headingCls, descriptionCls, checkmark, button } from './lightbox.card.style.js';
export { tokens as universalLightboxCardTokens } from './lightbox.card.style.js';
import { CardPreview } from './lightbox.preview.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const UniversalLightboxCard = withSlots(function UniversalLightboxCard(props) {
  const contextMenu$1 = props.slots.findOne("ContextMenu");
  return /*#__PURE__*/jsxs("div", {
    ref: props.ref,
    className: cx(wrapper, props.className, resets.rootCls),
    children: [contextMenu$1?.children && /*#__PURE__*/jsx("div", {
      className: contextMenu,
      children: contextMenu$1.children
    }), props.previewImageSrc ? /*#__PURE__*/jsx(CardPreview, {
      ...props
    }) : /*#__PURE__*/jsx(BadgeCard, {
      ...props
    })]
  });
});
function BadgeCard(props) {
  return /*#__PURE__*/jsxs("button", {
    onClick: props.onClick,
    "aria-label": `Aktiver ${props.title?.trim() || "opgaven"}`,
    className: cx(button, props.badgeImageSrc && "hasImage", props.hasShared && "hasShared"),
    children: [props.badgeImageSrc && /*#__PURE__*/jsxs("div", {
      className: badgeWrapperCls,
      children: [/*#__PURE__*/jsx("img", {
        className: imageCls,
        src: props.badgeImageSrc,
        alt: "",
        role: "presentation"
      }), props.indexOrLevel && /*#__PURE__*/jsx("span", {
        className: cx(badgeCls, props.audience),
        children: props.indexOrLevel
      })]
    }), props.title && /*#__PURE__*/jsx("h3", {
      className: headingCls,
      children: props.title.length > 40 ? props.title?.trim().substring(0, 38).trim() + "…" : props.title
    }), props.description && /*#__PURE__*/jsx("span", {
      className: descriptionCls,
      children: props.description.length > 100 ? props.description?.trim().substring(0, 98).trim() + "…" : props.description
    }), props.hasShared && /*#__PURE__*/jsx(Checkmark, {
      className: checkmark
    })]
  });
}

export { UniversalLightboxCard };
//# sourceMappingURL=lightbox.card.js.map
